<ng-template #popoverTaxes>
    <div class="container-taxes">
        <div class="taxe bold" *ngIf="rate">
            <p class="name-taxe">
              <strong *ngIf="fop === 'PAY_AT_DESTINATION'"> Valor en dólares</strong>
              <strong *ngIf="fop !== 'PAY_AT_DESTINATION'">{{ rate.key }}</strong>
            </p>
            <p class="value-taxe">
              <ng-container *ngIf="currencyCode === 'USD'; else notExperts">
                <strong>u$s {{ rate.value | Currency }}</strong>
              </ng-container>
              <ng-template #notExperts>
                <strong>{{ fop === 'PAY_AT_DESTINATION' ? 'u$s' : '$' }}
                {{ rate.value | Currency }}</strong>
              </ng-template>
            </p>
        </div>
        <ul>
            <li *ngIf="fop === 'PAY_AT_DESTINATION'">
              <div class="taxe">
                <p *ngIf="currencyCode !== 'USD'" class="name-taxe">El precio en pesos argentinos es estimativo</p>
              </div>
            </li>
            <li *ngFor="let charge of charges">
              <div class="taxe">
                <p class="name-taxe">{{ charge.key }}</p>
                <ng-container *ngIf="currencyCode === 'USD'; else chargeInPesos">
                  <p class="value-taxe">u$s {{ charge.value | Currency }}</p>
                </ng-container>
                <ng-template #chargeInPesos>
                  <p class="value-taxe">$ {{ charge.value | Currency }}</p>
                </ng-template>
              </div>
            </li>
        </ul>
        <div class="disclaimer" *ngIf="information">
          <mb-icon icon="exclamation-circle" class="icon-focus"></mb-icon>
          <p class="disclaimer__text not-pad"><strong *ngIf="information?.title">{{ information?.title }}.</strong> {{ information?.information[0] }}</p>
        </div>
      </div>


</ng-template>
<div
[mb-popover]="popoverTaxes"
[mbPopoverShow]="false"
mbPopoverColor="light"
mbPopoverPosition="left"
>

</div>
